import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Location} from "@angular/common";

import {Observable, of} from "rxjs";

import {DeviceDetectorService} from "ngx-device-detector";

import {serializeError} from 'serialize-error';

import packageJson from "../../../../package.json";

import {WebResponse} from "@commons/models/remote.response/WebResponse";

import {BaseHttpService} from "@shared/services-http/base-http.service";
import {UserHttpService} from "@shared/services-http/user-http.service";
import {SettingsService} from "@shared/services/settings.service";
import {AuthenticationService} from "@shared/services/authentication/authentication.service";

@Injectable({
  providedIn: 'root'
})
export class LogInApiHttpService extends BaseHttpService {

  private readonly version: string = packageJson.version;
  private readonly errorKeyLength = 50;
  private readonly sessionErrors = new Map<string, string>();
  private readonly logMethodUrl = '/LogInformation';

  private lastRequest = '';

  constructor(
    private httpClient: HttpClient,
    private userHttpService: UserHttpService,
    private deviceDetectorService: DeviceDetectorService,
    private location: Location,
    private settingsService: SettingsService,
    private authenticationService: AuthenticationService
  ) {
    super();
  }

  //informacja zapisywana jest w plikach logów api o nazwie  RequestLogs
  logInformation(information: string): Observable<WebResponse> {
    return this.log(information);
  }

  //informacja zapisywana jest w plikach logów api o nazwie  RequestLogs
  logError(error: any): Observable<WebResponse> {
    const errorString = JSON.stringify(serializeError(error));
    const errorKey = this.getErrorKey(errorString);
    if (this.isKnowError(errorString) || this.sessionErrors.has(errorKey)) {
      return of<WebResponse>();
    }
    this.sessionErrors.set(errorKey, error);
    return this.log(errorString);
  }

  setLastRequest(serializedRequest: string) {
    if (!serializedRequest.includes(this.logMethodUrl)) {
      this.lastRequest = serializedRequest;
    }
  }

  private log(information: string): Observable<WebResponse> {
    const finalInformation = this.getFinalInformation(information);
    const url = this.getUrl(this.logMethodUrl);
    return this.httpClient.post<WebResponse>(url, {Information: finalInformation});
  }

  private isKnowError(error: string): boolean {
    const knowErrors = [
      "WebSocket is already in CLOSING or CLOSED state.",
      '{}'
    ];
    const result = knowErrors.some(known => error.toLowerCase().startsWith(known.toLowerCase()));
    return result;
  }

  private getErrorKey(information: string) {
    return 'error-' + information.slice(0, this.errorKeyLength);
  }

  private getFinalInformation(information: string): string {
    const client = this.authenticationService.currentClient;
    const sessionId = this.authenticationService.sessionId;
    const user = this.userHttpService.userViewModel?.toString();
    const machineId = this.settingsService.getMachineId();
    const device = `${this.deviceDetectorService.browser} ${this.deviceDetectorService.browser_version}`;
    const url = this.location.path(true);
    const finalInformation =
      ` v.${this.version} | sessionId=${sessionId} | machineId=${machineId} | ${client} | ${user} | ${device} | ${url} | ${information} | ${this.lastRequest}`;

    return finalInformation;
  }

}
